import { FundingPolicyType } from "@shared";

export function getPolicyTypeFromTraditionalLTCQuote(quote: TraditionalLTCQuote): number {
  const carrier = quote.carrier?.toLowerCase() || '';
  const productName = quote.productName?.toLowerCase() || '';
  
  switch (true) {
    case carrier.includes('care assurance') && productName.includes('carescout'):
      return FundingPolicyType.careScoutCareAssurance; // carescoutCareAssurance
    default:
      return FundingPolicyType.longTermCareInsurance; // Traditional LTC Policy
  }
}
